module.exports = __webpack_public_path__ + "assets/d7c7465af45b0d7a92984fbff5f76c30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slides/3.png
// module id = 382
// module chunks = 1